import { useState } from 'react';
import { AxiosError } from 'axios';

export type ErrorMessageProviderState = {
  errorMsgTKey: string | null;
  setErrorMessage: (error: Error | undefined) => void;
  setCustomErrorMessage: (errorMessageKey: string) => void;
};

const useErrorMessageProviderState = (): ErrorMessageProviderState => {
  const [errorMsgTKey, setErrorMsgTKey] = useState<string | null>(null);

  const isAxiosError = (error: unknown): error is AxiosError => (error as AxiosError).isAxiosError === true;

  const setErrorMessage = (error: Error | undefined): void => {
    if (!error) {
      setErrorMsgTKey(null);
      return;
    }

    if (isAxiosError(error)) {
      const status = error.response?.status;

      // Ignore 401 here — authentication flows should handle redirects/login.
      if (status === 401) {
        return;
      }

      if (status === 400) {
        setErrorMsgTKey('badRequest');
        return;
      }
    }

    setErrorMsgTKey('default');
  };

  const setCustomErrorMessage = (errorMessageKey: string): void => {
    setErrorMsgTKey(errorMessageKey);
  };

  return {
    errorMsgTKey,
    setErrorMessage,
    setCustomErrorMessage,
  };
};

export default useErrorMessageProviderState;
